import * as actionsList from './actions'
import WrapperScreen from './screens/WrapperScreen'

export { default as reducer } from './reducer'

export const actions = actionsList

export default WrapperScreen
